module.exports = __webpack_public_path__ + "img/1.764ff8dc.png";